<template>
  <b-modal
    id="create-saved-search-modal"
    ref="modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('saved.search.l.create')"
    centered
    class="scan-menu-full-screen-modal"
    header-class="create-saved-search-modal-header"
    ok-variant="primary"
    @ok="onValidateClicked">

    <template #modal-header="{ close }">
      <div class="create-saved-search-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="create-saved-search-modal-img">
      </div>
    </template>

    <h4 class="page-title">
      {{ $t('saved.search.create.title') }}
    </h4>

    <p class="mt-3 mb-3 content" v-html="$t('saved.search.create.with.filters', {filters : this.filtersName})"></p>

    <b-form-group
      :invalid-feedback="alertName.invalidFeedback"
      class="small-text"
      label="Nom"
      label-for="identifier-input">
      <b-form-input
        id="identifier-input"
        v-model="alertName.value"
        :placeholder="$t('saved.search.create.placeholder')"
        :state="alertName.state"
        required
        @change="alertName.state = null">
      </b-form-input>
    </b-form-group>

  </b-modal>
</template>

<script>
import i18n from "../../i18n";
import api from "../../services/api";

export default {

  emits: ['saved-search-created'],

  props: {
    filtersData: {
      type: Object,
      required: true,
      default: () => ({})
    },
  },

  watch: {
    filtersData: {
      handler() {
        this.getDisplaySelectedValuesFiltersAlert();
      },
      deep: true,
      immediate: true,
    },
  },

  data() {
    return {
      filtersName: null,
      alertName: {
        value: null,
        state: null,
        invalidFeedback: null
      }
    };
  },

  async mounted() {
    await this.getDisplaySelectedValuesFiltersAlert();
  },

  methods: {
    async onValidateClicked(e) {
      e.preventDefault();

      if (!this.alertName.value || (this.alertName.value && this.alertName.value.trim() === "")) {
        this.alertName.state = false;
        this.alertName.invalidFeedback = this.$t('saved.search.invalidFeedBack');
        return;
      } else {
        this.alertName.state = null;
        this.alertName.invalidFeedback = null;
      }

      const fields = this.filtersData;
      const formData = new FormData();
      formData.append('name', this.alertName.value);

      if (fields.researchText && fields.researchText.trim() !== "") {
        formData.append('researchText', fields.researchText);
      }
      if (fields.address) {
        formData.append('address', fields.address);
      }
      if (fields.locationRadius) {
        formData.append('locationRadius', fields.locationRadius);
      }
      if (fields.latitude) {
        formData.append('latitude', fields.latitude);
      }
      if (fields.longitude) {
        formData.append('longitude', fields.longitude);
      }

      if (fields.vehicles) {
        formData.append('vehicles', fields.vehicles);
      }
      if (fields.brands) {
        formData.append('brands', fields.brands);
      }
      if (fields.models) {
        formData.append('models', fields.models);
      }
      if (fields.modelFinishes) {
        formData.append('modelFinishes', fields.modelFinishes);
      }
      if (fields.colors) {
        formData.append('colors', fields.colors);
      }
      if (fields.energies) {
        formData.append('energies', fields.energies);
      }
      if (fields.minFiscalPower) {
        formData.append('minFiscalPower', fields.minFiscalPower);
      }
      if (fields.maxFiscalPower) {
        formData.append('maxFiscalPower', fields.maxFiscalPower);
      }

      try {
        const response = await api({
          method: 'POST',
          url: '/savedSearch',
          data: formData,
        });
        this.$emit('saved-search-created', response.data.id, response.data.name);
        this.$refs.modal.hide();
      } catch (error) {
        console.error("Error saving SavedSearch:", error);
      }
    },

    async getDisplaySelectedValuesFiltersAlert() {
      let formData = new FormData();
      const fields = this.filtersData;

      if (fields.researchText && fields.researchText.trim() !== "") {
        formData.append('researchText', fields.researchText);
      }
      if (fields.address) {
        formData.append('address', fields.address);
      }
      if (fields.locationRadius) {
        formData.append('locationRadius', fields.locationRadius);
      }
      if (fields.latitude) {
        formData.append('latitude', fields.latitude);
      }
      if (fields.longitude) {
        formData.append('longitude', fields.longitude);
      }
      if (fields.vehicles) {
        formData.append('vehicles', fields.vehicles);
      }
      if (fields.brands) {
        formData.append('brands', fields.brands);
      }
      if (fields.models) {
        formData.append('models', fields.models);
      }
      if (fields.modelFinishes) {
        formData.append('modelFinishes', fields.modelFinishes);
      }
      if (fields.colors) {
        formData.append('colors', fields.colors);
      }
      if (fields.energies) {
        formData.append('energies', fields.energies);
      }
      if (fields.minFiscalPower) {
        formData.append('minFiscalPower', fields.minFiscalPower);
      }
      if (fields.maxFiscalPower) {
        formData.append('maxFiscalPower', fields.maxFiscalPower);
      }

      try {
        const response = await api({
          method: 'POST',
          url: '/search/getDisplaySelectedValuesFiltersAlert',
          data: formData,
        });
        this.filtersName = response.data.displaySelectedValuesText;
      } catch (error) {
        console.error("Error fetching filter display values:", error);
      }
    }
  },
};
</script>

<!-- not scoped car modal -->
<style>
#create-saved-search-modal .modal-header {
  background-color: var(--main-black-light) !important;
  padding-bottom: 0;
}

#create-saved-search-modal .modal-content,
#create-saved-search-modal .modal-body,
#create-saved-search-modal .modal-footer {
  background-color: var(--main-black-dark);
}

.create-saved-search-modal-subtitle {
  font-size: 24px;
}

#create-saved-search-modal .create-saved-search-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0;
  margin-left: 4rem;
  border-bottom: none;
}

.create-saved-search-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#create-saved-search-modal .modal-text {
  color: var(--main-grey-medium);
}

.create-saved-search-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.scan-menu-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  .scan-menu-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .scan-menu-container img {
    order: 2;
    align-self: center;
  }

  .scan-menu-container {
    text-align: center;
  }
}

#create-saved-search-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.scan-menu-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}

.scan-menu-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #create-saved-search-modal .modal-content {
    display: flex;
    overflow: auto;
    padding: 10px;
  }

  #create-saved-search-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #create-saved-search-modal .modal-header {
    padding-top: 0;
  }

  .create-saved-search-modal-img {
    margin-top: 20px;
    align-self: end;
  }

  .create-saved-search-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0 !important;
  }

  #create-saved-search-modal .modal-content {
    margin: 8px;
  }

  #create-saved-search-modal .modal-text,
  #create-saved-search-modal .scan-menu-container {
    padding: 10px;
  }

  #create-saved-search-modal .create-saved-search-modal-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #create-saved-search-modal .modal-content {
    overflow: auto;
  }

  .create-saved-search-modal-subtitle {
    font-size: 18px;
  }

  .create-saved-search-modal-header-content,
  #create-saved-search-modal .modal-text,
  .scan-menu-container {
    padding: 2px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/search/CreateSavedSearchModal.vue